export default __webpack_public_path__ + "static/media/foto9_pexels-ivan-samkov-5947556.ef79fe9a.jpg";